<script>
	// "이미지 에셋" 탭 최상위 컴포넌트.
	// 예전 씬-프롬프트(제목/이름/프롬프트) 방식은 제거하고, V3 이미지 자산 라이브러리
	// (assetId/버전관리, imageAssetApi + ImagePicker)를 인라인 관리 뷰로 대체.
	// 블록(BlockContext)이 참조하는 것과 동일한 공용 자산 라이브러리다.
	import ImagePicker from "./ImagePicker.svelte";
	import { chatAssetFolder } from "./imageAssetApi";

	export let chat;
	const tab = "scene";
</script>

{#if chat.isCurrentTab(tab)}
	<div class="chat-contents-wrap first tw-font-sans tw-text-foreground">
		<div class="tw-mb-3">
			<div class="tw-flex tw-items-center tw-gap-2">
				<h3 class="tw-text-[15px] tw-font-semibold tw-text-foreground">이미지 에셋 라이브러리</h3>
				<span class="tw-rounded-full tw-bg-muted tw-px-2 tw-py-0.5 tw-text-xs tw-text-muted-foreground">선택</span>
			</div>
			<p class="tw-mt-1 tw-text-xs tw-text-muted-foreground">
				업로드한 이미지는 폴더·버전으로 관리되며 블록에서 이 자산을 참조합니다. 이미지를 교체하면 참조된 곳에 일괄 반영됩니다.
			</p>
		</div>

		{#if chat?.chatId}
			<ImagePicker embedded chatId={chat.chatId} contextFolder={chatAssetFolder(chat)} />
		{:else}
			<div class="tw-rounded-lg tw-border tw-border-dashed tw-border-border tw-p-6 tw-text-center tw-text-sm tw-text-muted-foreground">
				먼저 AI챗을 저장하면 이미지 에셋을 관리할 수 있습니다.
			</div>
		{/if}
	</div>
{/if}

<style>
	.chat-contents-wrap {
		padding: 10px;
	}
</style>
